export const MENU_ITEMS = {
  DASHBOARD: 'Dashboard',
  PROJECTS: 'Projects',
  PERMIT_TEMPLATES: 'Permit Templates',
  OVERALL_PERMITS: 'Over All Permits',
  COMPARE: 'Compare',
  MEMBERS: 'Members',
  ROLES_AND_PERMISSIONS: 'Roles & Permissions',
  CITIES: 'Cities',
  SUPERADMIN: 'SuperAdmin',
  BLOCKED_ACCOUNTS: 'Blocked Accounts',
  SETTINGS: 'Settings',
} as const

export const ROUTES = {
  DASHBOARD: '/city-clerk/$id/dashboard',
  PROJECTS: '/city-clerk/$id/projects',
  PERMIT_TEMPLATE: '/city-clerk/$id/permit-template',
  OVERALL_PERMITS: '/city-clerk/$id/overall-permits',
  COMPARE: '/city-clerk/$id/compare',
  MEMBERS: '/city-clerk/members',
  ROLES_AND_PERMISSIONS: '/city-clerk/roles-and-permissions',
  SUPERADMIN_OVERVIEW: '/superadmin/overview',
  SUPERADMIN_BLOCKED_ACCOUNTS: '/superadmin/blocked-accounts',
  SETTINGS: '/city-clerk/settings',
} as const

export const PLACEHOLDER_IDS = {
  NO_CITY_CLERK: 'new',
} as const

export const SIDEBAR_WIDTH = {
  COLLAPSED: '60px',
  EXPANDED: '256px',
} as const
